export const WASTE_BASE_PATH = `/waste`;
export const RoutesList = {
  WASTE_HOME: WASTE_BASE_PATH,
  TEST_LANDING_PAGE: '/',
  UPLOAD_PHOTO: WASTE_BASE_PATH + '/upload-photo',
  WASTE_DETAILS: WASTE_BASE_PATH + '/waste-details',
  WASTE_LOCATION: WASTE_BASE_PATH + '/waste-location',
  ADDITIONAL_DETAILS: WASTE_BASE_PATH + '/additional-details',
  EMAIL_CONFIRMATION_REPORT: WASTE_BASE_PATH + '/email-confirmation-report',
  YOUR_DETAILS: WASTE_BASE_PATH + '/your-details',
  CONFIRMATION: WASTE_BASE_PATH + '/confirmation',
  WASTE_LOGIN_PAGE: WASTE_BASE_PATH + '/login',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
  CALLBACKS: WASTE_BASE_PATH + '/callbacks/*',
};

export const steps = [
  {
    label: 'Upload photo',
    urlPaths: [RoutesList.UPLOAD_PHOTO],
  },
  {
    label: 'Waste details',
    urlPaths: [
      RoutesList.WASTE_DETAILS,
      RoutesList.WASTE_LOCATION,
      RoutesList.ADDITIONAL_DETAILS,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.EMAIL_CONFIRMATION_REPORT, RoutesList.YOUR_DETAILS],
  },
];
